import React from 'react';
import { ThemeProvider } from 'styled-components';

import lightScheme from 'lib/schemes/light';
import darkScheme from 'lib/schemes/dark';
import NavigationProvider from 'providers/navigation';
import ColorModeProvider, { ColorMode } from 'providers/colorMode';
import { PageContext } from 'providers/navigation';
import ColorSchemeProvider, { ColorSchemeContext } from 'providers/colorScheme';
import TypographyProvider, { TypographyContext } from 'providers/typography';
import Head from 'components/head';
import Menu from 'components/menu';
import Section from 'components/section';
import Article from 'components/article';

const TABLET_WIDTH = 730
interface Props {
  children: JSX.Element;
  pageContext: PageContext;
}

function Layout({ children, pageContext }: Props) {
  const isArticle =
    pageContext.frontmatter != null &&
    typeof pageContext.frontmatter.title !== 'undefined' &&
    typeof pageContext.frontmatter.publishedAt !== 'undefined';

  return (
    <NavigationProvider pageContext={pageContext}>
      <ColorModeProvider>
        <ColorSchemeProvider
          schemes={{
            [ColorMode.DARK]: darkScheme,
            [ColorMode.LIGHT]: lightScheme,
          }}
        >
          <ColorSchemeContext.Consumer>
            {(colorScheme) => (
              <TypographyProvider>
                <TypographyContext.Consumer>
                  {(typography) => (
                    <ThemeProvider
                      theme={{
                        ...typography,
                        colorScheme,
                        width: TABLET_WIDTH,
                      }}
                    >
                      <Head pageContext={pageContext} />
                      <Section>
                        <Menu />
                      </Section>
                      {isArticle ? (
                        <Article
                          cover={pageContext.frontmatter!.cover}
                          published={pageContext.frontmatter!.published}
                          publishedAt={pageContext.frontmatter!.publishedAt!}
                          updatedAt={pageContext.frontmatter!.updatedAt}
                          subtitle={pageContext.frontmatter!.subtitle}
                          title={pageContext.frontmatter!.title!}
                        >
                          {children}
                        </Article>
                      ) : (
                        <Section>{children}</Section>
                      )}
                    </ThemeProvider>
                  )}
                </TypographyContext.Consumer>
              </TypographyProvider>
            )}
          </ColorSchemeContext.Consumer>
        </ColorSchemeProvider>
      </ColorModeProvider>
    </NavigationProvider>
  );
}

export default Layout;
